import { Avatar, Button, Chip, Dialog, DialogActions, DialogContent, Divider, Fab, Grid } from '@material-ui/core';
import React, { createRef } from 'react';
import CustomUserMenu from '../../commons/CustomUserMenu';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import ChartsChestionare from './ChartsChestionare';
import { ReactComponent as SignInSolid } from './Icoane Font Awesome/sign-in-alt-solid.svg'
import SelecteazaUserRaport from './SelecteazaUserRaport';
import ChartsSesiuni from './ChartsSesiuni'
import html2canvas from 'html2canvas'
import SpecificComponent from '../../commons/SpecificComponent';

export default class RaportChestionareGeneral extends SpecificComponent {
    constructor(props) {
        super(props);

        this.chartsClass = []
        this.state = {
            openList: false,
            intrebari:[],
            intrebariNr:0,
            showUsers:false
        }
    }

    componentDidMount() {
    }




    filterRaport = async() => {
        console.warn('this.props.raport :>> ', this.props.raport);

    

        this.chartsClass = []

        let intrebariNoi = []

        if (this.props.raport.raport_data) {

            for(let q = 0 , r = this.props.utilizatoriSelectati.length; q < r ; q++ ){
                let evaluari = this.props.raport.raport_data.evaluari.filter(evl => Number(evl.id_user_aprobare) === Number(this.props.utilizatoriSelectati[q].id_user_aprobare))


                console.log('evaluari :>> ', evaluari);
                console.log('this.props.raport_data :>> ', this.props.raport.raport_data);
    
                let intrebari = JSON.parse(JSON.stringify(this.props.raport.raport_data.intrebari))

                console.log('intrebari :>> ', intrebari);
    
                for (let i = 0, n = intrebari.length; i < n; i++) {
    
    
                    for (let j = 0, m = intrebari[i].raspunsuri.length; j < m; j++) {
    
                        intrebari[i].raspunsuri[j].rezultate = []
                        intrebari[i].raspunsuri[j].rezultate_evaluare = []
                        intrebari[i].nume_utilizator = evaluari[0].nume
                        intrebari[i].poza_utilizator = evaluari[0].poza
                        intrebari[i].id_utilizator = evaluari[0].id_user_aprobare
                       
    
                        let sumaRaspuns = 0
    
                        for (let k = 0, o = evaluari.length; k < o; k++) {
    
    
                            let filterRaspunsuriOptiuneRaspuns = evaluari[k].raspunsuri.filter(rasp => rasp.id_optiune_raspuns === intrebari[i].raspunsuri[j].id_optiune_raspuns)
    
                            filterRaspunsuriOptiuneRaspuns = filterRaspunsuriOptiuneRaspuns.filter(rasp => rasp.raspuns !== null)
                            sumaRaspuns = Math.floor(((filterRaspunsuriOptiuneRaspuns.length * 100) / evaluari[k].completari_finalizate) || 0)
                            // console.log('filterRaspunsuriOptiuneRaspuns :>> ', filterRaspunsuriOptiuneRaspuns);
                            // console.log('sumaRaspuns :>> ', sumaRaspuns);
                            if(sumaRaspuns === 0){
                                sumaRaspuns = 1
                            }
                            intrebari[i].raspunsuri[j].rezultate.push(sumaRaspuns)
                            // console.log('evaluari[k] :>> ', evaluari[k]);
    
                            if (evaluari[k].tip === 'evaluare_clienti') {
    
                                intrebari[i].raspunsuri[j].rezultate_evaluare.push('Clienti')
                            } else if (evaluari[k].tip === 'evaluare_sefi') {
                                intrebari[i].raspunsuri[j].rezultate_evaluare.push('Manager')
                            } else {
                                intrebari[i].raspunsuri[j].rezultate_evaluare.push('Colegi')
                            }



    
                        }

                       
    
    
                    }

                    intrebariNoi.push(intrebari[i])
                }

            }




           

            // console.log('intrebaritoReturn :>> ', intrebari);
            // console.log('intrebariNr :>> ', this.state.intrebariNr);

            console.log('intrebariNoi :>> ', intrebariNoi);

            this.setState({ intrebari: intrebariNoi, intrebariNr:this.state.intrebariNr + 1 }, () =>{
                // console.warn('this.chartClass :>> ', this.chartsClass);

                for(let i = 0 , n = this.chartsClass.length; i < n ; i++){
                    if(this.chartsClass[i].current){
                        this.chartsClass[i].current.changeRender()
                    }
                }
            })
        }



       console.warn('stop loading')

    }


    returnCharts = (i, idx) =>{


        let newRef = createRef()

        this.chartsClass.push(newRef)

        let refComp = <ChartsChestionare
        raspunsuri={i.raspunsuri}
        ref={newRef}
        loading={true}
        startLoading={this.props.startLoading}
        stopLoading={this.props.stopLoading}
    />
        
    return refComp
        
    }


    u = new Utils()



    salveazaSiInchide = () =>{
        this.setState({showUsers:false}, ()=>{
            this.props.salveazaSiInchide()
        })
    }


    pictureToCanvas = async (id) => {

        // console.log('id :>> ', id);

        

            html2canvas(document.getElementById(id)).then(async (canvas) => {
                // console.log('canvas :>> ', canvas);


                let img = canvas.toDataURL("image/png")
                let link = document.createElement('a');
                link.download = 'file.png'
                link.href = img
                link.click()


                let file = await fetch(img)

                let myFile;

                let idEv = this.props.ideval

                if (file.ok) {
                    let res = await file.blob()

                    if (res) {
                        myFile = new File([res], "NewCanvas", { type: res.type })
                    }
                }

               



            });
        

    }


    scrollRight = (idx) => {
        let container = document.getElementsByClassName('scroll-detaliu');
    
        // console.log('container :', container);
    
    
        

            
    
          // console.log('container[i] :>> ', container[i]);
          let containerScroll = container[idx].scrollLeft
    
          // console.log('containerScroll :>> ', containerScroll);
    
          container[idx].scrollTo({
            top: 0,
            left: containerScroll + 250,
            behavior: 'smooth'
          })
        
    
    
      }
    
      scrollLeft = (idx) => {
        let container = document.getElementsByClassName('scroll-detaliu');
    
        // console.log('container :', container);
    
    
  
          let containerScroll = container[idx].scrollLeft
    
          // console.log('containerScroll :>> ', containerScroll);
    
          container[idx].scrollTo({
            top: 0,
            left: containerScroll - 250,
            behavior: 'smooth'
          })
        
      }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'md'}
                >

                    <DialogActions >
                        <Fab onClick={this.props.dialogClose}
                            className="pm-round-button-dialog"
                            style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
                        >
                            <i style={{ color: 'black', fontSize: 28, fontWeight: 500 }} className='material-icons'>close</i>
                        </Fab>
                    </DialogActions>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <h2  >{this.dictionary.pontaje.evaluareGenerala} </h2>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                <Grid container>
                                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <h5 style={{ textAlign: 'left', fontWeight: 400, margin: 10 }}>{this.dictionary.evaluari.sesiunea}: <span style={{ fontWeight: 600 }}>{this.props.raport.raport_data.sesiune ? this.props.raport.raport_data.sesiune.nume : ''}</span></h5>
                                    </Grid>
                                    {/* <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <h5 style={{ textAlign: 'left', fontWeight: 400, margin: 10 }}>Completare: <span style={{ fontWeight: 500, color: this.props.raport.raport_data.completare_color }}>{this.props.raport.raport_data.completare}%</span></h5>
                                    </Grid> */}
                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <h5 style={{ textAlign: 'left', fontWeight: 400, margin: 10 }}>{this.dictionary.evaluari.finalizatNoCaps}: <span style={{ fontWeight:600, color: this.props.raport.finalizat_la_creare === 1 ? 'rgb(24 165 58)' : 'red' }}>{this.props.raport.finalizat_la_creare === 1 ? 'DA' : 'NU'}</span> </h5>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <h5 style={{ textAlign: 'left', fontWeight: 400, margin: 10 }}>{this.dictionary.pontaje.dataGenerarii}: <span style={{ fontWeight: 600 }}>{this.u.dataPoint(this.props.raport.la_data)}</span> </h5>
                                    </Grid>
                                </Grid>

                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                        <div style={{ position: 'relative' }}>
                                            <input
                                                id='titluRaport'
                                                style={{ width: '90%' }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='titlu'
                                                value={this.props.raport.titlu || ''}
                                                placeholder={this.dictionary.evaluari.denumireRaport}
                                                onChange={this.props.raportTitluChange}
                                                onBlur={this.props.updateTitluRaport}
                                            />




                                            <label className='inputLabelPM' htmlFor='titluRaport'>{this.dictionary.evaluari.denumireRaport}</label>

                                        </div>
                                    </Grid>
                                    <Grid style={{
                                        textAlign: 'left',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        display: 'flex'
                                    }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <Button className='add-button-green' onClick={()=>{this.pictureToCanvas('export-canvas')}}  >
                                            <SignInSolid className=' iconSvg' style={{ marginRight: 10, width: 18, height: 18 }} />
                                 Exporta Raport
                                </Button>

                                    </Grid>

                                    

                                    {this.props.raport.raport_data.acelasi_chestionar &&
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Divider style={{width:'100%'}}/>

                                        <Grid style={{marginTop:20, marginBottom:20}} container>
                                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                <span style={{ fontSize: 16, fontWeight:600}}>{this.dictionary.evaluari.afisarePentru}:
                                                
                                         
                                                  </span>
                                                </Grid>
                                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                        {this.props.utilizatoriSelectati.map((u,idx)=>{
                                                            return(
                                                                <Chip 
                                                                style={{backgroundColor:'rgb(62 138 230 )', marginRight:10, padding:5, marginBottom:20}}
                                                                    key={idx} 
                                                                    label={u.nume} 
                                                                    onDelete={()=>{this.props.deleteUtilizatorSelectat(u) } }
                                                                    color="primary" 
                                                                    deleteIcon={<i style={{fontSize: 21,
                                                                        fontWeight: 500,
                                                                        backgroundColor: 'white',
                                                                        color: 'rgb(62 138 230 )',
                                                                        borderRadius: '50%'}} className='material-icons'>close</i>}
                                                                    />
                                                            )
                                                        })}

                                                        <Avatar
                                                         onClick={()=>{this.setState({showUsers: true})}}
                                                         style={{     width: 28,
                                                            height: 28,
                                                            justifyContent: 'center',
                                                            display: 'inline-flex',
                                                            background: '#19a63c',
                                                            textAlign: 'center', }}>
                                                        <i style={{ verticalAlign: '-webkit-baseline-middle', color: 'white', }} className='material-icons'>add</i>
                                                    </Avatar>
                                                </Grid>
                                        </Grid>
                                        
                                  

                                        <Divider style={{width:'100%'}}/>

                                    </Grid>
                                }

                                    {/* <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <div style={{ marginTop: 30 }}>
                                            <CustomUserMenu
                                                user={this.props.userEvaluat}
                                                clearInput={() => {

                                                    this.props.clearInput()

                                                }}
                                                openList={() => { this.setState({ openList: true }) }}
                                                closeList={() => { this.setState({ openList: false }) }}
                                                showList={this.state.openList}
                                                users={this.props.useri}
                                                selectUser={this.props.selectUser}

                                            />

                                        </div>

                                    </Grid> */}
                                </Grid>
                            </Grid>


                            <div id='export-canvas' style={{width:'100%', height:'100%'}}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>

                                    {!this.props.raport.raport_data.acelasi_chestionar && 
                                     <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                     <ChartsSesiuni
                                 sesiuni={this.props.raport.raport_data.sesiune.sub_sesiuni}
                               
                             />
                                     </Grid>
                                    }

                                   

                              

                                {/* {this.props.sesiune.acelasi_chestionar && 
                                <ChartsChestionare
                                raspunsuri={i.raspunsuri}
                                ref={newRef}
                            />
                                } */}

                                    {this.props.raport.raport_data.acelasi_chestionar && 
                                    this.state.intrebari.map((i, idx) => {
                                        return (
                                            <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid container>
                                                    <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                        <Grid container>
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <h4 style={{ textAlign: 'left', marginBottom: 10 }}> {idx + 1}. {i.intrebare}</h4>
                                                    </Grid>

                                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Grid container>
                                                            {i.raspunsuri.map((r, idx2) => {
                                                                return (
                                                                    <Grid key={idx2} style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                        <span style={{ fontSize: 14, }}> {this.u.alfabet[idx2]}) {r.label_optiune_raspuns}</span>
                                                                    </Grid>

                                                                )
                                                            })}
                                                        </Grid>
                                                    </Grid>
                                                        </Grid>
                                                    </Grid>


                                                    <Grid style={{paddingTop:20}} item xs={3} sm={3} md={3} lg={3} xl={3} >
                                                        <span style={{display:'block', fontSize:14, paddingLeft:10}}>{this.dictionary.evaluari.resultsFor}</span>
                                                        <div className='pm-custom-user-select-option'  >
                                                                    <div>
                                                                        {
                                                                            i.poza_utilizator &&
                                                                            <div
                                                                                className='pm-angajati-picture'
                                                                                style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + i.poza_utilizator}')`, width: 30, height: 30, marginLeft: 10 }}>

                                                                            </div>
                                                                        }
                                                                        {!i.poza_utilizator &&

                                                                            <Avatar
                                                                                className='pm-angajati-picture'
                                                                                style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, height: 30, width: 30, backgroundColor: this.u.culoriUtilizatori(i.id_utilizator) }}>
                                                                                {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                                                {/* <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(u.nume)} </span> */}
                                                                                <i className='material-icons'>person</i>
                                                                            </Avatar>
                                                                            // <Avatar onClick={uClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                        }
                                                                        <span className='pm-custom-user-select-text'>{i.nume_utilizator}</span>
                                                                    </div>

                                                                    <div style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        paddingRight: 3
                                                                    }}>

                                                                    </div>




                                                                </div>

                                                    </Grid>
                                                

                                                    {i.raspunsuri.length > 0 &&
                                                        <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            {this.returnCharts(i,idx ) }
                                                        </Grid>
                                                    }


                                                </Grid>

                                                <Grid container>
                                                        <Grid style={{textAlign:'left'}} item xs={6} sm={6} md={6} lg={6} xl={6} >

                                                            <Fab onClick={() =>{this.scrollLeft(idx)}} className='scroll-buttons-charts'>
                                                                <i className='material-icons'>keyboard_arrow_left</i>
                                                            </Fab>
                                                        </Grid>
                                                        <Grid style={{textAlign:'right'}} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                            <Fab onClick={()=>{this.scrollRight(idx)}} className='scroll-buttons-charts'>
                                                            <i className='material-icons'>keyboard_arrow_right</i>
                                                            </Fab>
                                                        </Grid>
                                                    </Grid>

                                            </Grid>
                                        )

                                    })
                                    }
                                   

                                </Grid>
                            </Grid>
                                        
                                    </div>


                           
                        </Grid>
                    </DialogContent>



                </Dialog>


                <SelecteazaUserRaport 
                    open = {this.state.showUsers}
                    dialogClose = {()=>{this.setState({showUsers:false})}}
                    departamente={this.props.raport.raport_data.departamente}
                    selecteazaDepartament={this.props.selecteazaDepartament}
                    selecteazaAngajat = {this.props.selecteazaAngajat}
                    salveazaSiInchide={this.salveazaSiInchide}
                    />
            </div >
        );
    }
}